// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".location-info[data-v-2eec3c21]{display:flex;flex-flow:column}.location-info__code-header[data-v-2eec3c21],.location-info__location-header[data-v-2eec3c21]{font-weight:700}.location-info>span[data-v-2eec3c21]{white-space:nowrap;font-size:1.75rem;text-transform:capitalize}", ""]);
// Exports
module.exports = exports;
